import { ListingType } from '../../../modules/storefront/listingCardCreation/types'
import { STOREFRONT_ROUTES } from '../constants'

export const getCreatePath = (type?: ListingType) =>
  type === ListingType.BUTTON
    ? STOREFRONT_ROUTES.CREATE_BUTTON
    : STOREFRONT_ROUTES.CREATE_LISTING_CARD
